import { gql } from '@/lib/graphql/gql'

export const CREATE_STATIC_SITE_QUERY = gql`
  query CreateStaticSite($idCompany: String!) {
    company(id: $idCompany) {
      id
      staticSites {
        id
        total
      }
      sevallaBilling {
        id
        creditUsage {
          id
          remainingCredits
        }
      }
      defaultPaymentMethod {
        id
        expYear
        expMonth
      }
      projects {
        id
        items {
          id
          displayName
        }
      }
    }
  }
`

export const DETECT_FRAMEWORKS_QUERY = gql`
  query DetectFramework(
    $idRemoteRepository: String!
    $branch: String!
    $gitType: GitType!
  ) {
    detectFrameworkForStaticSite(
      idRemoteRepository: $idRemoteRepository
      branch: $branch
      gitType: $gitType
    ) {
      name
      type
      buildCommand
      nodeVersion
      publishDirectory
    }
  }
`

export const CREATE_STATIC_SITE_MUTATION = gql`
  mutation createStaticSite(
    $idCompany: String!
    $idProject: String
    $source: StaticSiteSource
    $displayName: String!
    $repoUrl: String!
    $defaultBranch: String!
    $autoDeploy: Boolean!
    $idRemoteRepository: String!
    $gitType: GitType!
    $installCommand: String
    $buildCommand: String
    $rootDirectory: String
    $publishedDirectory: String
    $indexFile: String
    $errorFile: String
    $nodeVersion: String
    $envVars: [StaticSiteEnvVarParam]
    $isPreviewEnabled: Boolean
  ) {
    createStaticSite(
      idCompany: $idCompany
      idProject: $idProject
      source: $source
      displayName: $displayName
      repoUrl: $repoUrl
      defaultBranch: $defaultBranch
      autoDeploy: $autoDeploy
      idRemoteRepository: $idRemoteRepository
      gitType: $gitType
      installCommand: $installCommand
      buildCommand: $buildCommand
      rootDirectory: $rootDirectory
      publishedDirectory: $publishedDirectory
      indexFile: $indexFile
      errorFile: $errorFile
      nodeVersion: $nodeVersion
      envVars: $envVars
      isPreviewEnabled: $isPreviewEnabled
    ) {
      id
      name
    }
  }
`
